let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2cNE1")).then(() => parcelRequire('bjfCW'));